import { useContext, useEffect, useRef, useState } from "react";
import { FormUtility } from "../../../Utility/FormUtility";
import Input from "../../../Form/Input";
import Select from "../../../Form/Select";
import ToastContext from "../../../../contexts/toast";
import StatusContext from "../../../../contexts/status";
import { RichiestaService } from "../../../../services/RichiestaService";
import { DatiUtenza } from "../../../../models/DatiUtenza";
import DatePicker from "../../../Form/DatePicker";
import moment from "moment";
import Radio from "../../../Form/Radio";
import Checkbox from "../../../Form/Checkbox";
import AlertMessage from "../../../Utility/Alert/AlertMessage";
import province from "../../../Utility/json/province";
import provinceToscane from "../../../Utility/json/provinceToscane";
import tuttiComuni from "../../../Utility/json/tuttiComuni";

const Step3 = (props) => {
  const masks = {
    maskCap: '00000', maskTel:'0000000000'
  };

  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);
  const [inSave, setInSave] = useState(false);
  const [richiestaDatiBeneficiario, setRichiestaDatiBeneficiario] = useState(
    new DatiUtenza()
  );
  const [allStati, setAllStati] = useState(null);
  const [stati, setStati] = useState(null);
  const [cittadinanze, setCittadinanze] = useState(null);
  const [provinces, setProvinces] = useState(null);
  const [comuni, setComuni] = useState(null);
  const [dirty, setDirty] = useState(false);

  const [etaMillesimo, setEtaMillesimo] = useState(null);

  const [provinceOnlyToscana, setProvinceOnlyToscana] = useState(null);
  const [comuniOnlyToscana, setComuniOnlyToscana] = useState(null);

  const previousBtnFunction = props.previousBtnFunction;
  const nextBtnFunction = props.nextBtnFunction;
  const afterSubmitFunction = props.afterSubmitFunction;

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);
  const utility = new FormUtility();
  const formRef = useRef(null);

  const [onChangeValueReset, setOnChangeValueReset] = useState(null);

  const regExprFiscalCode =
    "^([A-Za-z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[ABCDEHLMPRSTabcdehlmprst][0-9LMNPQRSTUVlmnpqrstuv]{2}[A-Za-z][0-9LMNPQRSTUVlmnpqrstuv]{3}[A-Za-z])$";

  const titoliDiStudio = [
    { value: "Nessun Titolo", key: "NESSUN_TITOLO" },
    { value: "Licenza elementare", key: "LICENZA_ELEMENTARE" },
    { value: "Licenza media", key: "LICENZA_MEDIA" },
  ];

  const richiestaService = new RichiestaService();

  const onPrevBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) previousBtnFunction();
  };

  const onNextBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) nextBtnFunction();
  };

  useEffect(() => {
    if (props.nazioni) {
      let nations = [ ...props.nazioni ];
      const italia = nations.find((nazione) => nazione.nome === "Italia");

      nations.sort((a, b) => (a.nome.localeCompare(b.nome)));
      nations = nations.filter((nazione) => nazione.nome !== "Italia");
      nations.unshift(italia);
      setAllStati([...nations]);
      setStati([...nations]);

      nations.sort((a, b) => (a.cittadinanza.localeCompare(b.cittadinanza)));
      nations = nations.filter((nazione) => nazione.nome !== "Italia");
      nations.unshift(italia);
      setCittadinanze([...nations]);
    };
  }, [props.nazioni]);

  useEffect(() => {
    return () => {
      statusContext.removeEvent("onbeforeunload");
    };
  }, []);

  useEffect(() => {
    if (dirty) {
      props.onChangedValue();
    }
  }, [dirty]);

  useEffect(() => {
    if (!allStati) return;

    const data = { ...props.richiesta?.richiestaDatiBeneficiario };

    const richiestaRapportoBeneficiario =
      props.richiesta?.richiestaRapportoBeneficiario;

    if (data?.codiceFiscale) {
      data.eta = utility.ottieniEtaDaCodiceFiscale(data.codiceFiscale);
      data.dataNascita = moment(
        utility.ottieniDataNascitaDaCodiceFiscale(data.codiceFiscale)
      ).format("YYYY-MM-DD");
    }

    if (
      richiestaRapportoBeneficiario?.tipoRichiedente === "STUDENTE_MAGGIORENNE"
    ) {
      if (provinceOnlyToscana === null || !!provinceOnlyToscana) {
        setProvinceOnlyToscana(false);
        const provs = [ ...province ].sort((a, b) => a.denominazione_provincia.localeCompare(b.denominazione_provincia));
        setProvinces(provs);
      }

      setStati([...allStati]);
    } else {
      if (provinceOnlyToscana === null || !provinceOnlyToscana) {
        setProvinceOnlyToscana(true);
        const provincesToscane = [ ...provinceToscane ].sort((a, b) => a.denominazione_provincia.localeCompare(b.denominazione_provincia));
        setProvinces(provincesToscane);
      }

      setStati(allStati ? [allStati.find((n) => n.nome === "Italia")] : []);
    }

    if (data?.statoResidenza === 1) {
      if (richiestaDatiBeneficiario.provRes !== data.provRes) {
        setComuniOnlyToscana(false);
        const munis = [ ...tuttiComuni ].filter(el => el.denominazione_provincia === data.provRes);
        setComuni(munis.sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
      }
    } else if (provinceOnlyToscana === null || !comuniOnlyToscana) {
      setComuniOnlyToscana(true);
      const munis = [ ...tuttiComuni ].filter(el => el.denominazione_regione === 'Toscana');
      setComuni(munis.sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
    }

    const codiceFiscale =
      richiestaDatiBeneficiario.codiceFiscale?.toUpperCase() ?? "";
    richiestaDatiBeneficiario.eta =
      utility.ottieniEtaDaCodiceFiscale(codiceFiscale);
    richiestaDatiBeneficiario.dataNascita = moment(
      utility.ottieniDataNascitaDaCodiceFiscale(codiceFiscale)
    ).format("YYYY-MM-DD");
    setEtaMillesimo(utility.ottieniEtaMillesimoDaCodiceFiscale(codiceFiscale));

    setRichiestaDatiBeneficiario({ ...data });

    checkHiddenFlag();

    onModifiedData(false);
  }, [props.richiesta, allStati]);

  const getComuni = (provincia, type) => {
    setComuniOnlyToscana(false);
    const comuni = [...tuttiComuni ].filter(el => el.denominazione_provincia === provincia);
    switch (type) {
      case "Residenza":
        setComuni(comuni.sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
        break;
      default:
        break;
    }
  };

  const checkHiddenFlag = () => {
    const richiestaDatiRichiedente = props.richiesta?.richiestaDatiRichiedente;
    const comuneResidenzaData = richiestaDatiRichiedente?.comuneResidenza;
    const comuneResidenza = props.comuniRichiedente?.find(
      (c) => c.id === comuneResidenzaData
    );
    return (
      !comuneResidenza ||
      comuneResidenza.denominazione_regione !== "Toscana" ||
      props.richiesta?.richiestaRapportoBeneficiario?.tipoRichiedente ===
        "STUDENTE_MAGGIORENNE"
    );
  };

  const checkDisabledForResidenza = (checkToscana = false) => {
    const richiestaRapportoBeneficiario =
      props.richiesta?.richiestaRapportoBeneficiario;
    const richiestaDatiRichiedente = props.richiesta?.richiestaDatiRichiedente;
    const comuneResidenzaData = richiestaDatiRichiedente?.comuneResidenza;
    const comuneResidenza = comuni?.find((c) => c.id === comuneResidenzaData);
    return (
      richiestaRapportoBeneficiario?.tipoRichiedente ===
        "STUDENTE_MAGGIORENNE" &&
      (!checkToscana ||
        !comuneResidenza ||
        comuneResidenza?.denominazione_regione !== "Toscana")
    );
  };

  const checkErrorDataResidenza = () => {
    const tipoRichiedente =
      props.richiesta?.richiestaRapportoBeneficiario?.tipoRichiedente;
    if (tipoRichiedente !== "STUDENTE_MAGGIORENNE") {
      return false;
    }

    const comuneResidenzaData =
      props.richiesta?.richiestaDatiRichiedente?.comuneResidenza;
    const comuneResidenza = comuni?.find(
      (c) => c.id === parseInt(comuneResidenzaData)
    );
    return (
      !comuneResidenza || comuneResidenza?.denominazione_regione !== "Toscana"
    );
  };

  const onChangeFlagResidenzaAsRichiedente = async (event) => {
    const target = event.target;

    const richiestaDatiRichiedente = props.richiesta?.richiestaDatiRichiedente;
    const checked = event.target.checked;
    if (checked) {
      richiestaDatiBeneficiario["statoResidenza"] =
        richiestaDatiRichiedente["statoResidenza"];
      richiestaDatiBeneficiario["provRes"] =
        richiestaDatiRichiedente["provRes"];
      richiestaDatiBeneficiario["comuneResidenza"] =
        richiestaDatiRichiedente["comuneResidenza"];
      richiestaDatiBeneficiario["viaResidenza"] =
        richiestaDatiRichiedente["viaResidenza"];
      richiestaDatiBeneficiario["civicoResidenza"] =
        richiestaDatiRichiedente["civicoResidenza"];
      richiestaDatiBeneficiario["capResidenza"] =
        richiestaDatiRichiedente["capResidenza"];
    } else {
      richiestaDatiBeneficiario["statoResidenza"] = null;
      richiestaDatiBeneficiario["provRes"] = null;
      richiestaDatiBeneficiario["comuneResidenza"] = null;
      richiestaDatiBeneficiario["viaResidenza"] = null;
      richiestaDatiBeneficiario["civicoResidenza"] = null;
      richiestaDatiBeneficiario["capResidenza"] = null;
    }

    richiestaDatiBeneficiario[target.name] = checked;
    setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });

    setComuniOnlyToscana(null);
    setComuni([...props.comuniRichiedente]);

    onModifiedData();
  };

  const onChangeStato = async (event, type, field) => {
    const target = event.target;
    richiestaDatiBeneficiario[field] = target.value;
    richiestaDatiBeneficiario["prov" + type.substring(0, 3)] = null;
    richiestaDatiBeneficiario["comune" + type] = null;
    richiestaDatiBeneficiario["via" + type] = null;
    richiestaDatiBeneficiario["civico" + type] = null;
    richiestaDatiBeneficiario["cap" + type] = null;

    setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });

    onModifiedData();
  };

  const onChangeCodiceFiscale = (event) => {
    const value = event.target.value;
    if (value.length === 16) {
      richiestaDatiBeneficiario.eta = utility.ottieniEtaDaCodiceFiscale(
        value.toUpperCase()
      );
      richiestaDatiBeneficiario.dataNascita = moment(
        utility.ottieniDataNascitaDaCodiceFiscale(value.toUpperCase())
      ).format("YYYY-MM-DD");
      setEtaMillesimo(
        utility.ottieniEtaMillesimoDaCodiceFiscale(value.toUpperCase())
      );
    } else {
      richiestaDatiBeneficiario.eta = null;
      richiestaDatiBeneficiario.dataNascita = null;
    }

    richiestaDatiBeneficiario.codiceFiscale = value;

    setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });

    onModifiedData();
  };

  const onChangeValue = async (event, field = "value", targetName = null) => {
    const target = event.target;
    const name = targetName ?? target.name;

    if (!!props.richiesta?.richiestaRapportoBeneficiario && 
        !!props.richiesta?.richiestaIscrizioneScolastica &&
        (
          name === 'nome' ||
          name === 'cognome' ||
          name === 'codiceFiscale'
        )
    ) {
      setOnChangeValueReset(richiestaDatiBeneficiario[name] !== props.richiesta?.richiestaRapportoBeneficiario?.[name]);
    }

    richiestaDatiBeneficiario[name] = target[field];

    setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });

    onModifiedData();
  };

  const onModifiedData = (updateDirty = true) => {
    if (validate) {
      setTimeout(() => {
        setFormErrors(false);
      }, 0);
    }

    if (updateDirty) {
      statusContext.addEvent("onbeforeunload");
      setDirty(true);
    }
  };

  const checkEtaValue = () => {
    if (etaMillesimo < 10) {
      return "Non è possibile presentare domanda per studenti con età inferiore ai 10 anni";
    }

    if (richiestaDatiBeneficiario.eta >= 24) {
      return 'Non è possibile presentare domanda per studenti con età uguale o maggiore di 24 anni';
    }

    return null;
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();

    if(utility.checkLastCharCf(richiestaDatiBeneficiario.codiceFiscale?.toUpperCase())) {
      setInputErrors(prev => [...new Set([...prev, "codiceFiscaleBeneficiario"])]);
      const cfBeneficiario = [...formRef.current.elements].filter(el => el.id === "codiceFiscaleBeneficiario");
      cfBeneficiario[0].focus();
      return;
    }

    if (!validity) {
      setFormErrors();
      return;
    }

    if (checkEtaValue() || checkErrorDataResidenza()) {
      return;
    }

    if (!dirty) {
      onNextBtnClick();
      return;
    }

    setInSave(true);

    setInputErrors([]);

    richiestaDatiBeneficiario.codiceFiscale =
      richiestaDatiBeneficiario.codiceFiscale?.toUpperCase() ?? "";
    richiestaDatiBeneficiario.comuneNascita =
      richiestaDatiBeneficiario.codiceFiscale.substring(11, 15);
    const giorno = parseInt(
      richiestaDatiBeneficiario.codiceFiscale.substring(9, 11)
    );
    richiestaDatiBeneficiario.sesso = giorno > 31 ? "F" : "M";

    richiestaService
      .saveStep3(props.richiesta.id, richiestaDatiBeneficiario)
      .then((result) => {
        const msg = onChangeValueReset
                      ? "Dati beneficiario salvati con successo!\n\rE' necessario ricompilare i dati sull’iscrizione scolastica"
                      : "Dati beneficiario salvati con successo!";
        toastContext.success(msg);
        statusContext.removeEvent("onbeforeunload");

        setInSave(false);
        setDirty(false);

        afterSubmitFunction(result);
        onNextBtnClick(null);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setInSave(false);
      });
  };

  return (
    <div className=" rtds-my-12 ">
      <div className="rtds-mb-6 ">
        <h1 className="rtds-text-2xl rtds-font-bold">Dati del beneficiario</h1>
      </div>
      <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
        <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className="rtds-font-bold rtds-no-underline"
              title="obbligatorio"
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id="hasValidationForm"
          className="has-js-validation-form rtds-py-6 rtds-space-y-4"
          onSubmit={sendData}
        >
          <h2 className="rtds-text-xl rtds-font-bold">
            Dati identificativi dello studente
          </h2>

          <div className="rtds-field-row">
            <Input
              label={"Codice Fiscale dello studente"}
              id={"codiceFiscaleBeneficiario"}
              classInput={"rtds-text-sm rtds-input-placeholder rtds-uppercase"}
              type={"text"}
              pattern={regExprFiscalCode}
              onChange={(event) => onChangeCodiceFiscale(event)}
              value={richiestaDatiBeneficiario.codiceFiscale || ""}
              disabled={
                props.richiesta?.richiestaRapportoBeneficiario
                  ?.tipoRichiedente === "STUDENTE_MAGGIORENNE"
              }
              maxLength={16}
              minLength={16}
              inputErrors={inputErrors}
              errorMessage={utility.checkFiscalCodeValidity(
                validate,
                richiestaDatiBeneficiario.codiceFiscale,
                regExprFiscalCode
              )}
              required
            />

            <Input
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Nome dello Studente"}
              id={"nomeBeneficiario"}
              classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
              type={"text"}
              onChange={(event) => onChangeValue(event, "value", "nome")}
              value={richiestaDatiBeneficiario.nome || ""}
              disabled={
                props.richiesta?.richiestaRapportoBeneficiario
                  ?.tipoRichiedente === "STUDENTE_MAGGIORENNE"
              }
              inputErrors={inputErrors}
              required
              maxLength={50}
            />

            <Input
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Cognome dello Studente"}
              id={"cognomeBeneficiario"}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"text"}
              onChange={(event) => onChangeValue(event, "value", "cognome")}
              value={richiestaDatiBeneficiario.cognome || ""}
              disabled={
                props.richiesta?.richiestaRapportoBeneficiario
                  ?.tipoRichiedente === "STUDENTE_MAGGIORENNE"
              }
              inputErrors={inputErrors}
              required
              maxLength={50}
            />
          </div>
          <div className="rtds-field-row">
            <Select
              label={"Cittadinanza dello Studente"}
              required
              id={"cittadinanzaBeneficiario"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) =>
                onChangeValue(event, "value", "cittadinanza")
              }
              baseOption={"Seleziona Cittadinanza"}
              options={cittadinanze}
              bindValue={"cittadinanza"}
              bindKey={"cittadinanza"}
              value={richiestaDatiBeneficiario.cittadinanza || ""}
              disabled={
                props.richiesta?.richiestaRapportoBeneficiario
                  ?.tipoRichiedente === "STUDENTE_MAGGIORENNE"
              }
            />
          </div>

          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          <h2 className="rtds-text-xl rtds-font-bold">Età dello studente</h2>
          <AlertMessage
              message="La data di nascita e l'età vengono calcolate automaticamente in base al Codice Fiscale inserito."
              iconName="mini--information-circle"
              title="Nota Bene!"
              classArticle="rtds-mb-6"
            />

          <div className="rtds-field-row">
            <DatePicker
              label={"Data di Nascita dello Studente"}
              id={"dataNascita"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"date"}
              defaultValue={richiestaDatiBeneficiario.dataNascita || ""}
              readOnly
              hideSubTitle
            />

            <Input
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Età dello Studente"}
              id={"eta"}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"text"}
              value={richiestaDatiBeneficiario.eta || ""}
              readOnly
            />
          </div>

          {validate && checkEtaValue() && (
            <AlertMessage
              title={"Età non corretta"}
              message={checkEtaValue()}
              classDiv={"rtds-text-error-dark"}
              classArticle={"rtds-bg-error-light"}
              iconName={"mini--exclamation-circle"}
            />
          )}

          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          <h2 className="rtds-text-xl rtds-font-bold">
            Residenza dello studente
          </h2>

          <div className="rtds-field-row">
            <Checkbox
              classDiv={"rtds-input-checkbox rtds-input--lg"}
              label={
                "Selezionare se la residenza dello studente è la stessa del richiedente"
              }
              id={"residenzaComeRichiedente"}
              inputErrors={inputErrors}
              classInput={""}
              onChange={(event) => onChangeFlagResidenzaAsRichiedente(event)}
              checked={
                richiestaDatiBeneficiario.residenzaComeRichiedente || false
              }
              disabled={!stati}
              hidden={checkHiddenFlag()}
            />
          </div>

          <div className="rtds-field-row">
            <Select
              label={"Stato dello Studente"}
              required
              id={"statoResidenzaBeneficiario"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) =>
                onChangeStato(event, "Residenza", "statoResidenza")
              }
              baseOption={"Seleziona Stato"}
              options={stati}
              bindValue={"nome"}
              bindKey={"id"}
              value={richiestaDatiBeneficiario.statoResidenza || ""}
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente
              }
            />

            <Select
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Provincia  dello Studente"}
              id={"provResBeneficiario"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) => {
                onChangeValue(event, "value", "provRes");
                getComuni(event.target.value, "Residenza");
              }}
              baseOption={"Seleziona Provincia"}
              options={provinces}
              bindValue={"denominazione_provincia"}
              bindKey={"denominazione_provincia"}
              value={richiestaDatiBeneficiario.provRes || ""}
              required={
                richiestaDatiBeneficiario.statoResidenza === 1 ||
                richiestaDatiBeneficiario.statoResidenza === "1"
              }
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente ||
                (richiestaDatiBeneficiario.statoResidenza !== 1 &&
                  richiestaDatiBeneficiario.statoResidenza !== "1")
              }
            />

            <Select
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Comune dello Studente"}
              id={"comuneResidenzaBeneficiario"}
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) =>
                onChangeValue(event, "value", "comuneResidenza")
              }
              baseOption={"Seleziona Comune"}
              options={comuni}
              bindValue={"denominazione"}
              bindKey={"id"}
              value={richiestaDatiBeneficiario.comuneResidenza || ""}
              required={richiestaDatiBeneficiario.provRes}
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente ||
                !richiestaDatiBeneficiario.provRes
              }
            />
          </div>
          <div className="rtds-field-row">
            <Input
              label={"Via dello Studente"}
              id={"viaResidenzaBeneficiario"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"text"}
              onChange={(event) =>
                onChangeValue(event, "value", "viaResidenza")
              }
              value={richiestaDatiBeneficiario.viaResidenza || ""}
              required={
                richiestaDatiBeneficiario.statoResidenza === 1 ||
                richiestaDatiBeneficiario.statoResidenza === "1"
              }
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente ||
                (richiestaDatiBeneficiario.statoResidenza !== 1 &&
                  richiestaDatiBeneficiario.statoResidenza !== "1")
              }
              maxLength={100}
            />

            <Input
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"Numero civico dello Studente"}
              id={"civicoResidenzaBeneficiario"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
              type={"text"}
              onChange={(event) =>
                onChangeValue(event, "value", "civicoResidenza")
              }
              value={richiestaDatiBeneficiario.civicoResidenza || ""}
              required={
                richiestaDatiBeneficiario.statoResidenza === 1 ||
                richiestaDatiBeneficiario.statoResidenza === "1"
              }
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente ||
                (richiestaDatiBeneficiario.statoResidenza !== 1 &&
                  richiestaDatiBeneficiario.statoResidenza !== "1")
              }
              maxLength={10}
            />

            <Input
              classDiv={"rtds-mt-3 lg:rtds-mt-0"}
              label={"CAP dello Studente"}
              id={"capResidenzaBeneficiario"}
              inputErrors={inputErrors}
              classInput={"rtds-text-sm rtds-input-placeholder"}
              type={"text"}
              onChange={(event) =>
                onChangeValue(event, "value", "capResidenza")
              }
              value={richiestaDatiBeneficiario.capResidenza || ""}
              required={
                richiestaDatiBeneficiario.statoResidenza === 1 ||
                richiestaDatiBeneficiario.statoResidenza === "1"
              }
              disabled={
                checkDisabledForResidenza() ||
                richiestaDatiBeneficiario.residenzaComeRichiedente ||
                (richiestaDatiBeneficiario.statoResidenza !== 1 &&
                  richiestaDatiBeneficiario.statoResidenza !== "1")
              }
              minLength={5}
              maxLength={5}
              mask={masks.maskCap}
            />
          </div>

          {validate && checkErrorDataResidenza() && (
            <AlertMessage
              title={"Controllo residenza"}
              message={
                "Non è possibile presentare domanda se lo studente non è residente in Toscana"
              }
              classDiv={"rtds-text-error-dark"}
              classArticle={"rtds-bg-error-light"}
              iconName={"mini--exclamation-circle"}
            />
          )}

          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          <h2 className="rtds-text-xl rtds-font-bold">
            Livello di istruzione dello studente
          </h2>

          <div className="rtds-field-row">
            <Select
              label={"Titolo di Studio dello Studente"}
              id={"titoloDiStudioPosseduto"}
              required
              inputErrors={inputErrors}
              classSelect={""}
              onChange={(event) => onChangeValue(event)}
              baseOption={"Seleziona Titolo di studio"}
              options={titoliDiStudio}
              bindValue={"value"}
              bindKey={"key"}
              value={richiestaDatiBeneficiario.titoloDiStudioPosseduto || ""}
            />
          </div>

          <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

          

          <div className="">
            <fieldset className="rtds-input-field rtds-gap-2">
              <legend className="rtds-input-field__label">
                {"Categoria di appartenenza dello studente"}
                <abbr
                  className="rtds-font-bold rtds-no-underline"
                  title="obbligatorio"
                >
                  *
                </abbr>
              </legend>
              <span className="rtds-input-field__hint">
                <span
                  className="rtds-input-field__description"
                  id="idInputDescription"
                >
                  Domanda presente per scopi statistici ai fini degli indicatori FSE. Selezionare una sola tra le categorie disponibili, scegliendo quella considerata prevalente
                </span>
              </span>

              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Persone con disabilità"}
                id={"PERSONE_CON_DISABILITA"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "PERSONE_CON_DISABILITA"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={
                  "Persone senza tetto o persone colpite da esclusione abitativa"
                }
                id={"SENZA_TETTO"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "SENZA_TETTO"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Appartenente a minoranze a rischio esclusione"}
                id={"APPARTENENTE_MINORANZE"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "APPARTENENTE_MINORANZE"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Partecipanti di origine straniera"}
                id={"PARTECIPANTI_ORIGINE_STRANIERA"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "PARTECIPANTI_ORIGINE_STRANIERA"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Cittadino/a di paesi terzi"}
                id={"CITTADINO_PAESI_TERZI"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "CITTADINO_PAESI_TERZI"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Partecipanti provenienti da zone rurali"}
                id={"ZONE_RURALI"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "ZONE_RURALI"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
              ></Radio>
              <Radio
                classDiv={"rtds-input-radio rtds-input--lg"}
                label={"Nessuna delle precedenti"}
                id={"NESSUNA_DELLE_PRECENDENTI"}
                checked={
                  richiestaDatiBeneficiario.categoriaAppartenenzaStudente ===
                  "NESSUNA_DELLE_PRECENDENTI"
                }
                onChange={(event) =>
                  onChangeValue(event, "id", "categoriaAppartenenzaStudente")
                }
                required={
                  !richiestaDatiBeneficiario.categoriaAppartenenzaStudente
                }
                inputErrors={inputErrors}
              ></Radio>

              
            </fieldset>
          </div>

          <div className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:rtds-justify-end rtds-justify-center">
            <div className="rtds-form-actions">
              <div
                className="rtds-inline-flex rtds-gap-1"
                role="group"
                aria-label="Salva"
              >
                <button
                  onClick={onPrevBtnClick}
                  type="button"
                  className="rtds-btn rtds-btn--secondary rtds-btn--icon-left rtds-group/button rtds-form-submit"
                  disabled={inSave}
                >
                  <svg
                    className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6  group-hover/button:-rtds-translate-x-1"
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{" "}
                  Indietro
                </button>
                <button
                  type="submit"
                  className="rtds-btn rtds-btn--icon-right rtds-group/button rtds-btn--primary rtds-form-submit "
                  disabled={
                    (validate &&
                      (checkEtaValue() || checkErrorDataResidenza())) ||
                    inSave
                  }
                >
                  Salva<span className="lg:sx-diplay-none"> e vai avanti</span>
                  {inSave ? (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                        />
                      </svg>
                      <span className="rtds-sr-only">Caricamento...</span>
                    </>
                  ) : (
                    <>
                      <svg
                        className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <use
                          xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                        />
                      </svg>
                    </>
                  )}
                </button>

                {props.children}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Step3;
